module.exports = __webpack_public_path__ + "static/media/login.bf69da04.png";